import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { ThermalPrinterComponent } from '../thermal-printer/thermal-printer.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-thermal-printer-list',
  templateUrl: './thermal-printer-list.component.html',
  styleUrls: ['./thermal-printer-list.component.css']
})
export class ThermalPrinterListComponent implements OnInit {

  public menu_item_id = '40';
  public add_auth;
  public edit_auth;
  public del_auth;

  private dp = [];
  displayedColumns = ['printer_name_en', 'printer_number', 'Printer_Type', 'edit', 'del'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<ThermalPrinterComponent>;
  @ViewChild(MatSort) sort: MatSort;

  model = { 'table_name': 'thermal_printer', 'printer_name_en': '', 'printer_number': '' };

  Success_Msg; Error_Msg; Del_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) { 
      this.getMessages(translate);
    }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });
  }

  ngOnInit() {
  }

  search() {

    let condition = "";

    if (this.model['printer_name_en'] != '')
      condition = " (`printer_name_en` LIKE '%" + this.model['printer_name_en'] + "%') AND ";
    let query = "SELECT * FROM `thermal_printer` WHERE" + condition + " `status` = '1'";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];


        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  newPrinter() {
    this.addDialogRef = this.dialog.open(ThermalPrinterComponent, {
      hasBackdrop: false,
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['status'] == 'success')
          this.search();
      });
  }

  editPrinter(row) {
    let dialog_data = {
      'table_name': 'thermal_printer', 'printer_id': row.printer_id,
      'printer_name_en': row.printer_name_en,
      'printer_number': row.printer_number,
      'printer_type': row.printer_type,
      'comment': row.comment
    };
    this.addDialogRef = this.dialog.open(ThermalPrinterComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        this.search();
      });
  }

  delPrinter(row) {
    if (confirm("نتيجة الحذف قد تؤثر على بيانات أخرى، هل أنت متأكد من رغبتك بالاستمرار؟")) {
      let values = [{ 'table_name': this.model['table_name'], 'printer_id': row.printer_id }];
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(" تمت العملية بنجاح ");
            this.search();
          }
          else {
            alert(" حدث خطأ الرجاء المحاولة مرة أخرى ");
          }
        });
    }
  }


}
